import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/technicians/')({
  component: TechnicianIndexPlaceholder,
});

function TechnicianIndexPlaceholder() {
  return (
    <div className="hidden h-full items-center justify-center p-6 text-sm text-muted-foreground md:flex">
      Select a technician to view details.
    </div>
  );
}
